import React from 'react'

function HomesLiving() {
  return (
    <div>HomesLiving</div>
  )
}

export default HomesLiving